import React, { useState, useRef, useEffect } from "react";
import Btn from "../Btn/Btn";
import TrackerIcon from "../Icons/TrackerIcon";
import MessageIcon from "../Icons/MessageIcon";
import styles from "./VesselMarkerPopup.module.css";
import { positionTypeDescriptions } from "../../constants/Position";
import { toDMSWithDirection } from "../../utils/geo";
interface VesselPopupProps {
    vesselName: string;
    keyId: string;
    latitude: number;
    longitude: number;
    speed?: number;
    heading?: number;
    positionType: string;
    positionTime: number;
    onTrackerClick: () => void;
    onMessageClick: () => void;
}

const VesselPopup: React.FC<VesselPopupProps> = ({
    vesselName,
    keyId,
    latitude,
    longitude,
    speed,
    heading,
    positionType,
    positionTime,
    onTrackerClick,
    onMessageClick,
}) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const btnRef = useRef<HTMLButtonElement>(null);

    return (
        <div className="text" style={{ position: "relative" }}>
            <h6>Tàu: {vesselName}</h6>
            <div>Mã thiết bị: {keyId}</div>
            <div>Vị trí: {toDMSWithDirection(latitude,true)}, {toDMSWithDirection(longitude,false)}</div>
            <div>Tốc độ: {speed ?? "N/A"} km/h</div>
            <div>Hướng: {heading ?? "N/A"}°</div>
            <div>
                Loại: {
                    positionType in positionTypeDescriptions
                        ? positionTypeDescriptions[positionType as keyof typeof positionTypeDescriptions]
                        : "N/A"
                }
            </div>
            <div>Cập nhật: {new Date(positionTime * 1000).toLocaleString()}</div>
            <div className={styles["popup-btn-container"]}>
                <Btn
                    className="text"
                    onClick={() => setMenuOpen((v) => !v)}
                    ref={btnRef}
                >
                    ⋮
                </Btn>
                <div
                    ref={menuRef}
                    className={`${styles["popup-outer-menu"]} leaflet-popup-content-wrapper text ${
                        menuOpen ? "" : `${styles["popup-outer-menu-hidden"]}`
                    }`}
                >
                    <Btn
                        className={`text ${styles["popup-outer-menu-item"]}`}
                        id="tracker-mode"
                        title="Theo dõi vị trí tàu thuyền"
                        onClick={onTrackerClick}
                    >
                        <TrackerIcon />
                    </Btn>
                    <Btn
                        className={`text ${styles["popup-outer-menu-item"]}`}
                        id="message-mode"
                        title="Tin nhắn"
                        onClick={onMessageClick}
                    >
                        <MessageIcon />
                    </Btn>
                </div>
            </div>
        </div>
    );
};

export default VesselPopup;